module.exports = __webpack_public_path__ + "img/mergdata_before_after_1.694c01fc.png";